/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Search_3Inputs */

const en_pc_tut_search_3 = /** @type {(inputs: Pc_Tut_Search_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press ⌘G to jump to the next match.`)
};

const zh_pc_tut_search_3 = /** @type {(inputs: Pc_Tut_Search_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按 ⌘G 跳到下一个匹配项。`)
};

/**
* | output |
* | --- |
* | "Press ⌘G to jump to the next match." |
*
* @param {Pc_Tut_Search_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_search_3 = /** @type {((inputs?: Pc_Tut_Search_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Search_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_search_3(inputs)
	return zh_pc_tut_search_3(inputs)
});
export { pc_tut_search_3 as "pc.tut.search.3" }